import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeaders, axiosInstance, logError } from "../../utils/helper";

const initialState = {
  data: [],
  selected: null,
  loading: false,
};

export const getTagList = createAsyncThunk("tag/getTagList", async (params) => {
  const res = await axiosInstance.get("store/tagList", { params, ...authHeaders() });
  const data = await res.data;
  return data;
});

const tag = createSlice({
  name: "tag",
  initialState,
  reducers: {
    setTag: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearTag: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTagList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTagList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result;
      })
      .addCase(getTagList.rejected, (state, action) => {
        state.loading = false;

        // logError(new Error(action.error?.message), {
        //   feature: "getTagList",
        //   actionType: action.type,
        // });
      });
  },
});

// Export actions and reducer
export const { setTag, clearTag } = tag.actions;
export default tag.reducer;
